<div *ngIf="isLoaded">
    <ng-template #contentPayment let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title">Incasare factura - {{contractData.seriesName}}{{contractData.seriesNumber}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label>Tipul de incasare</label>
                <select [(ngModel)]="paymentType"  name="type" #typeController="ngModel" class="form-control" required>
                    <option [ngValue]="undefined"> -- Selecteaza tipul de incasare -- </option>
                    <option value="Chitanta">Chitanta</option>
                    <option value="Card">Card</option>
                    <option value="CEC">CEC</option>
                    <option value="Bilet ordin">Bilet ordin</option>
                    <option value="Ordin plata">Ordin plata</option>
                    <option value="Mandat postal">Mandat postal</option>
                    <option value="Alta incasare">Alta incasare</option>
                </select>
                <div class="error-msg" *ngIf="!typeController.valid && (typeController.touched)">Acest camp este obligatoriu!</div>
            </div>
            <div class="form-group">
                <label>Data incasarii</label>
                <input type="date" class="form-control" [(ngModel)]="paymentDate" #dateController="ngModel"/>
                <div class="error-msg" *ngIf="!dateController.valid && (dateController.touched)">Acest camp este obligatoriu!</div>
            </div>
            <div class="form-group">
                <label>Valoarea incasata</label>
                <div class="input-group mb-2">
                    <input [(ngModel)]="paymentAmount" class="form-control mb-0" type="number" #amountController="ngModel">
                    <div class="input-group-append">
                        <div class="input-group-text">RON</div>
                    </div>
                    <div class="error-msg" *ngIf="!amountController.valid && (amountController.touched)">Acest camp este obligatoriu!</div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="c('Close click')">Anulare</button>
            <button type="button" class="btn btn-primary" (click)="payBill(paymentType, paymentDate, paymentAmount); c('Close click')" [disabled]="!typeController.valid || !dateController.valid || !amountController.valid">Incasare factura</button>
        </div>
    </ng-template>

    <div class="row">
        <div class="col-md-6 col-12 mb-4">
            <a routerLink="../../../contracte/editare-contract/{{contractData.id}}" class="btn text-white green-bg">Editeaza
                Contract</a>
        </div>
        <div class="col-md-6 col-12 text-right mb-4">
            <a routerLink="../../../contracte/lista-contracte" class="btn text-white blue-bg">Toate Contractele</a>
        </div>
    </div>

    <div class="card card-custom gutter-b">
        <div class="card-header">
            <div class="card-title">
                <h3 class="card-label">Nume Contract: {{contractData.name}}</h3>
            </div>
            <div class="card-title">
                <h3 class="card-label">Nr: {{contractData.docNumber}}</h3>
            </div>
        </div>
        <div class="card-body">
            <div class="row mb-10">
                <div class="col-12 mb-2">
                    <span class="font-weight-bold">Nume Client:</span> {{contractData.clientName}}
                </div>

                <div class="col-6">
                    <span class="font-weight-bold">Data Postare:</span> {{contractData.contractDate}}
                </div>
                <div class="col-6">
                    <span class="font-weight-bold">Data Expirare:</span> {{contractData.deadline}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <ul class="list-unstyled" *ngFor="let product of contractData.productList">
                        <li><span class="font-weight-bold mr-2">Nume Produs:</span>{{product.name}}</li>
                        <li><span class="font-weight-bold mr-2">Pret:</span>{{product.price}} Euro</li>
                        <hr>
                    </ul>
                </div>
                <div class="col-6">
                    <ul class="list-unstyled" *ngFor="let note of contractData.personalNotes">
                        <li><span class="font-weight-bold mr-2">Autor:</span>{{note.authorName}}</li>
                        <li><span class="font-weight-bold mr-2">Nota:</span>{{note.note}}</li>
                        <li><span class="font-weight-bold mr-2">Data Postare:</span>{{note.date}}</li>
                        <hr>
                    </ul>
                </div>
            </div>

            <div class="row mt-20" *ngIf="contractData.observation != ''">
                <div class="col-12">
                    <div class="alert observation-alert" role="alert">
                        <span class="font-weight-bold mr-2">Observatie:</span>{{contractData.observation}}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-transparent row align-items-center">
            <div class="col-md-6">
                <h4>Pret: {{contractData.totalPrice}} Euro</h4>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
                <a (click)="generatePdf()" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">Exporta in PDF <i class="icofont-file-pdf"></i></a>
            </div>

        </div>

    </div>

    <div class="card card-custom gutter-b">
        <div class="card-header">
            <div class="card-title">
                <h3 class="card-label">Facturare</h3>
            </div>
            <div class="card-title">
                <span *ngIf="billEmit === true" class="btn btn-light-success mr-3">Emisa</span>
                <span *ngIf="billPayed === 'Neplatita'" class="btn btn-light-danger">Neincasata</span>
                <span *ngIf="billPayed === 'Incasata partial'" class="btn btn-light-warning">Incasata partial</span>
                <span *ngIf="billPayed === 'Incasata integral'" class="btn btn-light-success">Incasata integral</span>

            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12 d-flex justify-content-between">
                    <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4" (click)="toSmartbill()"> Genereaza factura <i class="icofont-ui-file"></i></a>
                    <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4" (click)="downloadBill()" *ngIf="contractData.seriesNumber"> Vezi factura <i class="icofont-eye-alt"></i></a>
                    <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4" (click)="openPayment(contentPayment)" *ngIf="contractData.seriesNumber && (billPayed === 'Neplatita' || billPayed === 'Incasata partial')"> Incasare factura <i class="icofont-money-bag"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>
